// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Iframe_wrapper__L78ne"};